import React, { Component } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../actions/authActions";
import pageTransition from "../utils/pageTransition";
import {
  FaHome,
  FaChartLine,
  FaSortDown,
  FaBitcoin,
  FaSearchDollar,
  FaUserCircle,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onLogoutClick = (e) => {
    e.preventDefault();
    pageTransition();
    setTimeout(() => {
      this.props.logoutUser();
    }, 3000);
  };

  slideNav = (num) => {
    var numToggled = num;
    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      if (numToggled == null) {
        $("#nav").slideToggle();
        $(".menu").toggleClass("hidden");
      }
      if (numToggled == 1) {
        if ($(".dropdown.graph").hasClass("collapsed")) {
          $(".dropdown.graph").stop(true, true).slideToggle();
          $(".graph-filter-arrow").css("transform", "rotate(180deg)");
          $(".graph-filter-arrow").css("top", "7px");
          $(".dropdown.graph").removeClass("collapsed");
          $(".dropdown.graph").css("display", "flex");
        } else if (numToggled == 1) {
          $(".dropdown.graph").addClass("collapsed");
          $(".dropdown.graph").stop(true, true).slideToggle();
          $(".graph-filter-arrow").css("transform", "rotate(0deg)");
          $(".graph-filter-arrow").css("top", "-1px");
        }
      } else if (numToggled == 2) {
        if ($(".dropdown.acct").hasClass("collapsed")) {
          $(".dropdown.acct").stop(true, true).slideToggle();
          $(".acct-filter-arrow").css("transform", "rotate(180deg)");
          $(".acct-filter-arrow").css("top", "7px");
          $(".dropdown.acct").removeClass("collapsed");
          $(".dropdown.acct").css("display", "flex");
        } else if (numToggled == 2) {
          $(".dropdown.acct").addClass("collapsed");
          $(".dropdown.acct").stop(true, true).slideToggle();
          $(".acct-filter-arrow").css("transform", "rotate(0deg)");
          $(".acct-filter-arrow").css("top", "-1px");
        }
      }
    } else {
      if ($(".dropdown.graph").hasClass("collapsed") && numToggled == 1) {
        $(".dropdown.graph").stop(true, true).slideToggle();
        $(".graph-filter-arrow").css("transform", "rotate(180deg)");
        $(".graph-filter-arrow").css("top", "5px");
        $(".dropdown-wrapper .stock-icon, .graph-filter-arrow").css(
          "color",
          "white"
        );
        $(".dropdown.graph").removeClass("collapsed");
      } else if (numToggled == 1) {
        $(".dropdown.graph").addClass("collapsed");
        $(".dropdown.graph").stop(true, true).slideToggle();
        $(".graph-filter-arrow").css("transform", "rotate(0deg)");
        $(".graph-filter-arrow").css("top", "-6px");
        $(".dropdown-wrapper .stock-icon, .graph-filter-arrow").css(
          "color",
          "unset"
        );
      } else if ($(".dropdown.acct").hasClass("collapsed") && numToggled == 2) {
        $(".dropdown.acct").stop(true, true).slideToggle();
        $(".acct-filter-arrow").css("transform", "rotate(180deg)");
        $(".acct-filter-arrow").css("top", "5px");
        $(".dropdown-wrapper .acct-icon, .acct-filter-arrow").css(
          "color",
          "white"
        );
        $(".dropdown.acct").removeClass("collapsed");
      } else if (numToggled == 2) {
        $(".dropdown.acct").addClass("collapsed");
        $(".dropdown.acct").stop(true, true).slideToggle();
        $(".acct-filter-arrow").css("transform", "rotate(0deg)");
        $(".acct-filter-arrow").css("top", "-6px");
        $(".dropdown-wrapper .acct-icon, .acct-filter-arrow").css(
          "color",
          "unset"
        );
      }
    }
  };

  handleResize = (e) => {
    $(".menu").css("display", "block");
    $(".dropdown").css("flex-direction", "column");
  };

  componentDidMount() {
    $(window).resize(() => {
      this.handleResize();
    });
    $(".main-container").click(() => {
      var x = window.matchMedia("(max-width: 700px)");
      if (x.matches) {
        this.setState({ mobile: true });
        if (!$(".menu").hasClass("hidden")) {
          $("#nav").slideToggle();
          $(".menu").toggleClass("hidden");
        }
      } else {
        this.setState({ mobile: false });
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <div className="navbar">
        <div className="mobile-top-nav">
          <button
            className="mobile-nav"
            id="nav-menu"
            onClick={() => {
              this.slideNav();
            }}
          >
            <div className="icon-bar"></div>
            <div className="icon-bar"></div>
            <div className="icon-bar"></div>
          </button>
        </div>
        <div id="glowbar-mobile"></div>
        <div className="menu hidden" id="nav">
          <div className="img-wrapper">
            <div className="border-wrapper">
              <span></span>
            </div>
            <h1 className="m-title">TREND</h1>
            <img alt="logo" src={require("../img/logo.png")} />
          </div>
          <div className="links">
            <div className="first">
              <Link to="/dashboard">
                <FaHome />
                <p>Home</p>
              </Link>
              <div
                className="dropdown-wrapper"
                id="wrapper-1"
                onMouseEnter={() => this.slideNav(1)}
                onMouseLeave={() => this.slideNav(1)}
              >
                <div className="dropdown-btn">
                  <FaSearchDollar className="stock-icon" />
                  <FaSortDown className="graph-filter-arrow" />
                </div>
                <div className="dropdown graph collapsed">
                  <Link to="/stocks">
                    <FaChartLine className="stocks-icon" />
                    <p>Stocks</p>
                  </Link>
                  <Link to="/cryptos">
                    <FaBitcoin />
                    <p>Crypto</p>
                  </Link>
                </div>
              </div>
              <div
                className="dropdown-wrapper"
                id="wrapper-2"
                onMouseEnter={() => this.slideNav(2)}
                onMouseLeave={() => this.slideNav(2)}
              >
                <div className="dropdown-btn">
                  <FaUserCircle className="acct-icon" />
                  <FaSortDown className="acct-filter-arrow" />
                </div>

                <div className="dropdown acct collapsed">
                  <Link to="/account">
                    <FaCog />
                    <p>Settings</p>
                  </Link>
                  <a onClick={this.onLogoutClick}>
                    <FaSignOutAlt />
                    <p>Logout</p>
                  </a>
                </div>
              </div>
            </div>
            <div className="second"></div>
          </div>
          <div className="mobile-links">
            <div className="first">
              <Link to="/">
                <p>Home</p>
              </Link>
              <div className="dropdown-wrapper">
                <p
                  onClick={() => {
                    this.slideNav(1);
                  }}
                >
                  Trackers
                  <FaSortDown className="graph-filter-arrow" />
                </p>

                <div className="dropdown graph collapsed">
                  <Link to="/stocks">Stock Market</Link>
                  <Link to="/crypto">Crypto Currencies</Link>
                </div>
              </div>
              <div className="dropdown-wrapper">
                <div
                  className="dropdown-btn"
                  onClick={() => {
                    this.slideNav(2);
                  }}
                >
                  <p>
                    Account
                    <FaSortDown className="acct-filter-arrow" />
                  </p>
                </div>

                <div className="dropdown acct collapsed">
                  <Link to="/account">Settings</Link>
                  <a onClick={this.onLogoutClick}>Logout</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="glowbar"></div>
      </div>
    );
  }
}

Nav.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(Nav);
